import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import ReactCountryFlag from 'react-country-flag';

import Modal, {
  ModalAction,
  ModalBody,
  ModalButton,
  ModalHeader,
} from '../../components/Modal/Modal';
import { EnumLanguage } from '../../constants/enum';
import {
  setGeneralError,
  startConfirm,
} from '../../layout/components/UniversalModal/actions';
import { changeLanguage, setRingAllRestaurant } from './actions';
import { trans } from '../../localization';
import CheckBoxInput from '../../components/Common/CheckBoxInput';

import InputFormWrapper from '../../components/Common/InputFormWrapper';
import ChangePasswordModal from './components/ChangePasswordModel';
import { changePassword } from '../Login/actions';

import './Setting.scss';

function LanguageItem({ itemLanguage, language, changeLanguageConnect }) {
  const countryFlagStyle = {
    width: '40px',
    height: '40px',
  };
  const { value, icon } = itemLanguage;
  return (
    <div className="form-check form-check-inline">
      <input
        className="form-check-input"
        type="radio"
        name="inlineRadioOptions"
        id={`inlineRadio${value}`}
        value={value}
        checked={language === value}
        onChange={evt => changeLanguageConnect(evt.target.value)}
      />
      <label className="form-check-label" htmlFor={`inlineRadio${value}`}>
        <ReactCountryFlag styleProps={countryFlagStyle} code={icon} svg />
      </label>
    </div>
  );
}

class SettingModal extends Component {
  state = {
    isOpenDialogChangePassword: false,
  }

  handleOpenSettingModal = (isOpenDialogChangePassword) => {
    this.setState({ isOpenDialogChangePassword });
  };

  render() {
    const {
      setting,
      changeLanguageConnect,
      setRingAllRestaurantConnect,
      changePasswordConnect,
      setGeneralErrorConnect,
      openSettingModal,
      isOpenDialog,
      history
    } = this.props;
    const { isOpenDialogChangePassword } = this.state;
    const { language, notificationBell } = setting;
    const { isRingAllRestaurant } = notificationBell;
    const listLanguages = Object.keys(EnumLanguage).map(item => ({
      value: EnumLanguage[item].value,
      icon: EnumLanguage[item].icon,
    }));
    return (
      <React.Fragment>
        <Modal
          isOpen={isOpenDialog}
          onRequestClose={() => openSettingModal(false)}
          width="700px"
        >
          <ModalHeader closeButton>
            {trans('set_setting_management')}
          </ModalHeader>
          <ModalBody>
            <InputFormWrapper
              label={trans(
                'set_notification_when_have_order_at_another_restaurant',
              )}
              width={6}
              className="row-setting"
            >
              <CheckBoxInput
                value={isRingAllRestaurant}
                onChange={evt =>
                  setRingAllRestaurantConnect(evt.target.checked)
                }
              />
            </InputFormWrapper>
            <InputFormWrapper
              label={trans('set_language')}
              width={6}
              className="row-setting"
            >
              {listLanguages.map(itemLanguage => (
                <LanguageItem
                  key={itemLanguage.value}
                  language={language}
                  itemLanguage={itemLanguage}
                  changeLanguageConnect={changeLanguageConnect}
                />
              ))}
            </InputFormWrapper>
            <InputFormWrapper
              label={trans('set_change_password')}
              width={6}
              className="row-setting"
            >
              <button
                type="button"
                className="btn btn-white mr-2"
                onClick={() => this.handleOpenSettingModal(true)}
              >
                {trans('set_change')}
              </button>
            </InputFormWrapper>
            <InputFormWrapper
              label={trans('set_delete_account')}
              width={6}
              className="row-setting"
            >
              <button
                type="button"
                className="btn btn-white mr-2"
                onClick={() =>{
                  history.push('/account-deletion');
                  openSettingModal(false)
                }}
              >
                {trans('btn_account_deletion')}
              </button>
            </InputFormWrapper>
          </ModalBody>
          <ModalAction>
            <ModalButton
              type="cancel"
              onClick={() => openSettingModal(false)}
            >
              {trans('common_close')}
            </ModalButton>
          </ModalAction>
        </Modal>
        <ChangePasswordModal
          changePassword={changePasswordConnect}
          setGeneralError={setGeneralErrorConnect}
          openChangePasswordModal={this.handleOpenSettingModal}
          isOpenDialog={isOpenDialogChangePassword}
          openSettingModal={openSettingModal}
        />
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => ({
  setting: state.setting,
  login: state.login,
});

const mapDispatchToProps = dispatch => ({
  changeLanguageConnect: (language) => {
    dispatch(changeLanguage(language));
  },
  setRingAllRestaurantConnect: (isRingAllRestaurant) => {
    dispatch(setRingAllRestaurant(isRingAllRestaurant));
  },
  startConfirmConnect: (title, message, onOk, onCancel) => {
    dispatch(
      startConfirm({
        title,
        message,
        onOk,
        onCancel,
      }),
    );
  },
  changePasswordConnect: model => dispatch(changePassword(model)),
  setGeneralErrorConnect: (message) => {
    dispatch(setGeneralError(message));
  },
});

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(SettingModal),
);



// WEBPACK FOOTER //
// ./foody/src/pages/Setting/SettingModal.jsx